import * as t from 'io-ts'
import {
  ProjectGrantDraftApp,
  PaidApp,
  PaymentWaitApp,
  PostReportApp,
  PreReportApp,
  RecoveredApp,
  RecoveryApp,
  RejectedApp,
  ReviewApp,
  SentApp,
  SigningApp,
  GeneralGrantDraftApp
} from './apps'

export * from './apps'
export * from './app-partials'
export * from './decision'
export * from './report'
export * from './signer'
export * from './form-data'
export type {
  ProjectGrantFormData,
  GeneralGrantFormData
} from '@espoon-voltti/nuora-domain/grants/form-data'

export type PublishedApp =
  | PaidApp
  | PaymentWaitApp
  | PostReportApp
  | PreReportApp
  | RecoveredApp
  | RecoveryApp
  | RejectedApp
  | ReviewApp
  | SentApp

export type GrantApp =
  | ProjectGrantDraftApp
  | GeneralGrantDraftApp
  | SigningApp
  | PublishedApp

export const ProjectGrantType = t.literal('PROJECT_GRANT')
export type ProjectGrantType = t.TypeOf<typeof ProjectGrantType>

export const GeneralGrantType = t.literal('GENERAL_GRANT')
export type GeneralGrantType = t.TypeOf<typeof GeneralGrantType>
